import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ISbRichtext } from '@storyblok/js';
import { StoryblokService } from 'src/app/services/storyblok.service';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { StoryblokLinkUrlPipe } from '../../storyblok-link-url.pipe';
import { StoryblokRichTextPipe } from '../../storyblok-rich-text.pipe';
import { StoryblokLink } from '../../storyblok-types';
import { StoryblokDirective } from '../../storyblok.directive';
import { BlockStyle, BlockWrapperComponent } from '../block-wrapper/block-wrapper.component';

@Component({
  selector: 'app-product-feature-list',
  standalone: true,
  templateUrl: './product-feature-list.component.html',
  styleUrls: ['./product-feature-list.component.scss'],
  imports: [
    CommonModule,
    BlockWrapperComponent,
    StoryblokDirective,
    SvgComponent,
    RouterLink,
    StoryblokRichTextPipe,
    StoryblokLinkUrlPipe,
  ],
})
export class ProductFeatureListComponent implements OnChanges {
  @Input() _uid: string; // just here to prevent errors
  @Input() component: string; // just here to prevent errors
  @Input() _editable: string;
  @Input() replacer?: (key: string) => string;
  @Input() style: BlockStyle[];

  @Input() items: string[];
  @Input() title: string;

  mappedProductFeatures: {
    _editable: string;
    featurePageLink: StoryblokLink;
    title: string;
    text: ISbRichtext;
    comingSoon: boolean;
    new: boolean;
  }[];

  private storyblokService = inject(StoryblokService);

  ngOnChanges(): void {
    const relationships = this.storyblokService.getGlobalData('relationships');

    this.mappedProductFeatures = this.items
      .map(id => {
        return relationships.find(f => f.uuid === id)?.content;
      })
      .filter(Boolean);
  }
}
